import React from 'react';
import { Checkbox as AntdCheckbox } from 'antd';
import type { CheckboxProps as AntCheckboxProps } from 'antd/lib/checkbox';
import 'antd/es/checkbox/style/index.less';
import './index.less';

interface CheckboxProps extends AntCheckboxProps {}

const Checkbox: React.FC<CheckboxProps> = (props) => {
    return <AntdCheckbox {...props} />;
};

export default Checkbox;
